Mesh.bindAll = function (deviceTypes, meshes) {
    for (var n in meshes) {
        // TODO Guard needed for data inconsistencies on the server - meshes contains null objects

        if (!meshes[n]) {
            continue;
        }

        Utils.inheritMethods(meshes[n], new Mesh());

        meshes[n].bind(deviceTypes);
    }

    return meshes;
};

Mesh.bind = function (deviceTypes, mesh) {
    Utils.inheritMethods(mesh, new Mesh());

    mesh.bind(deviceTypes, true);

    return mesh;
};

/**
 *
 */
function Mesh() {
    /**
     *
     */
    Mesh.prototype.bind = function (deviceTypes, bindChildren) {
        this.class = "Mesh";

        if (bindChildren) {
            for (var n in this.nodes) {
                Node.bind(deviceTypes, this.nodes[n], this);
            }

            for (var n in this.groups) {
                MeshGroup.bind(this.groups[n], this);
            }
        }
    };

    /**
     *
     */
    Mesh.prototype.getNode = function (id) {
        for (var n in this.nodes) {
            if (this.nodes[n].id === id) {
                return this.nodes[n];
            }
        }

        return null;
    };

    /**
     *
     */
    Mesh.prototype.getNodeByUuid = function (uuid) {
        for (var n in this.nodes) {
            if (this.nodes[n].uuid === uuid) {
                return this.nodes[n];
            }
        }

        return null;
    };

    /**
     *
     */
    Mesh.prototype.getDeviceByPath = function (path) {
        var path = path.split('.');

        return this.getNode(path[0]).getDevice(path[1]);
    };
}
